// The token lives in sessionStorage: one OAuth popup tab only, cleared when it
// closes. localStorage leaked it to every app.mindcloud.co tab for its 14-day
// lifetime, where it replaced a signed-in user's Clerk identity on later OAuth
// popups and the API refused the request (COMPANY_SCOPE_MISMATCH).
const EMBEDDED_END_USER_TOKEN_STORAGE_KEY = 'embeddedEndUserJwt';

export default EMBEDDED_END_USER_TOKEN_STORAGE_KEY;
